import axios from "axios";
import helpers from "../shared/fleetbox-helpers";
import { bus } from "../main";
import qs from "qs";

let baseurl = process.env.VUE_APP_BASE_URL;
if(typeof overrideApiUrl != "undefined") baseurl = overrideApiUrl;

const instance = axios.create({
	baseURL: baseurl
});

instance.interceptors.request.use(config => {
	config.headers.Authorization = "Bearer " + localStorage.getItem("fr-token");
	return config;
});

instance.interceptors.response.use(
	res => {
		return res;
	},
	error => {
		if (error.response && (error.response.status === 400 || error.response.status === 500)) {
			var status = "ok";
			var messages = [];
			var errors = {};
			if (error.response && error.response.data) {
				status = error.response.data.status;
				messages = error.response.data.messages;
				errors = error.response.data.errors;
			}
			bus.$emit("responseNotification", {
				status: status,
				messages: messages,
				errors: errors
			});

			console.log(error);
			return Promise.reject(error);
		} else {
			console.log(error);
			return Promise.reject(error);
		}
	}
);

//instance.headers['Authorization'] = ; // +
//instance.defaults.headers.get['Accepts'] = 'application/json';

const appId = "2912A6F1-5877-40E3-9ED7-38CD6272019A";

const api = {
	//#region Authentication
	loginConfiguration: function() {
		return new Promise(function(resolve, reject) {
			instance
			.get("/loginconfig")
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
		});
	},

	login: function(company, userName, password, token) {
		var data = {};
		if (token) {
			data = {
				token: token
			};
		} else {
			data = {
				company: company,
				userName: userName,
				password: password,
				appId: appId
			};
		}
		return new Promise(function(resolve, reject) {
			instance
				.post("/login", data)
				.then(res => {
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	loginAAD: function(company, token) {
		var data = data = {
			company: company,
			token: token,
			appId: appId
		};
		return new Promise(function(resolve, reject) {
			instance
				.post("/login-aad", data)
				.then(res => {
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	verify: function(company, userName, oneTimePassword) {
		var data = {
			company: company,
			userName: userName,
			oneTimePassword: oneTimePassword,
			appId: appId
		};
		return new Promise(function(resolve, reject) {
			instance
				.post("/login/verify", data)
				.then(res => {
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	setNewPassword: function(company, userName, tempPassword, newPassword, newPasswordConfirm) {
		var data = {
			company: company,
			userName: userName,
			tempPassword: tempPassword,
			newPassword: newPassword,
			newPasswordConfirm: newPasswordConfirm,
			appId: appId
		};
		return new Promise(function(resolve, reject) {
			instance
				.post("/account/set-pwd", data)
				.then(res => {
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	resetPassword: function(company, userName) {
		var data = {
			company: company,
			userName: userName,
			appId: appId
		};
		return new Promise(function(resolve, reject) {
			instance
				.post("/account/reset", data)
				.then(res => {
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	getMyAccount: function() {
		return new Promise(function(resolve, reject) {
			instance
				.get("/account/me")
				.then(res => {
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},
	//#endregion

	//#region Analytics
	getFleetStatus: function() {
		return new Promise(function(resolve) {
			instance.get("/analytics/fleet-status").then(res => {
				resolve(res.data);
			});
		});
	},

	getTripsCounter: function() {
		return new Promise(function(resolve) {
			instance.get("/analytics/trips-counter").then(res => {
				resolve(res.data);
			});
		});
	},

	getAlarms: function(params) {
		return new Promise(function(resolve) {
			instance
				.get("/analytics/alarms-counter", {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				});
		});
	},

	exportAnalyticsXlsx: function(report, type) {
		return new Promise(function(resolve) {
			instance.get(`/analytics/export/${report}${type && type == "csv" ? "?format=" + type : ""}`).then(res => {
				resolve(res);
			});
		});
	},
	//#endregion

	//#region configs

	/* CONFIGS */
	getMenuListData: function() {
		return new Promise(function(resolve) {
			instance.get("/config/menu").then(res => {
				resolve(res.data);
			});
		});
	},

	getViewConfig: function(section) {
		return new Promise(function(resolve, reject) {
			instance
				.get("/config/view/" + section)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	setUserVisibleColumns: function(data) {
		return new Promise(function(resolve) {
			instance
				.post("/config/view/user/columns", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	setCompanyConfig: function(data) {
		return new Promise(function(resolve) {
			instance
				.post("/config/settings/company", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	/* END CONFIGS */
	//#endregion

	//#region Alarms
	/* ALARMS */

	getAlarmsData: function(params) {
		return new Promise(function(resolve, reject) {
			//var qs = helpers.toQueryString(params);
			instance
				.get(`/alarms`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	/* END ALARMS */
	//#endregion

	//#region Diagnostic
	/* DIAGNOSTIC */

	getDiagnosticSummaryData: function(params) {
		return new Promise(function(resolve) {
			instance
				.get(`/diagnosis/summary`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				});
		});
	},
	getDiagnosticData: function(params) {
		return new Promise(function(resolve) {
			instance
				.get(`/diagnosis`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				});
		});
	},

	/* END DIAGNOSTIC */
	//#endregion

	//#region Trips

	/* TRIPS */

	getTripsSummaryData: function(params) {
		return new Promise(function(resolve) {
			instance
				.get(`/trips/summary`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				});
		});
	},

	getTripsData: function(params) {
		return new Promise(function(resolve) {
			instance
				.get(`/trips`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				});
		});
	},

	getTripDataById: function(id) {
		return new Promise(function(resolve) {
			instance
				.get(`/trips/${id}`)
				.then(res => {
					resolve(res.data);
				});
		});
	},

	getTripDataByIdsWithAlarmAndDiagnosis: function(params) {
		return new Promise(function(resolve) {
			instance
				.post(`/trips-detail`, params)
				.then(res => {
					resolve(res.data);
				});
		});
	},

	/* END TRIPS */

	//#endregion

	/* VEHICLES */

	getVehiclesLookup: function(params, vehicleIdFilterField) {
		return new Promise(function(resolve) {
			var qs = helpers.toQueryString(params);
			instance.get(`/vehicles/lookup?${qs}`).then(res => {
				if (vehicleIdFilterField == "code") {
					var resItemsByCode = res.data.items.map(function(vehicle) {
						return {
							id: vehicle.id,
							name: vehicle.name,
							number_plate: vehicle.code,
							code: vehicle.code,
							box_active: vehicle.box_active
						};
					});

					res.data.items = resItemsByCode;
				}

				resolve(res.data);
			});
		});
	},

	getVehiclesData: function(params) {
		return new Promise(function(resolve) {
			var qs = helpers.toQueryString(params);

			instance.get("/vehicles?" + qs).then(res => {
				resolve(res.data);
			});
		});
	},

	getVehicleDetail: function(id) {
		return new Promise(function(resolve, reject) {
			instance
				.get(`/vehicle/${id}`)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	saveVehicleDetail: function(id, car_sharing, division_id, purpose, fringe_benefit, groups, utilization_area, expulsion_date) {
		var data = {
			id: id,
			car_sharing: car_sharing,
			division_id: division_id,
			purpose: purpose,
			fringe_benefit: fringe_benefit,
			groups: groups,
			utilization_area: utilization_area,
			expulsion_date: expulsion_date
		};

		return new Promise(function(resolve, reject) {
			instance
				.post("/vehicle", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	saveVehiclesDriversAssociation: function(inserted, updated, deleted) {
		var data = {
			insert: inserted,
			update: updated,
			delete: deleted
		};
		return new Promise(function(resolve, reject) {
			instance
				.post("/vehicle-driver/bulk", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	exportXlsx: function(section, params) {
		return new Promise(function(resolve) {
			//var qs = helpers.toQueryString(params);

			instance
				.get(`/${section}/export?`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res);
				});
		});
	},

	exportXlsxReverseGeocoding: function(section, params) {
		return new Promise(function(resolve) {
			//var qs = helpers.toQueryString(params);

			instance
				.get(`/${section}/export-job?`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					bus.$emit("successNotification", "Il report sarà spedito via email");
					resolve(res);
				});
		});
	},

	exportChartXlsx: function(section, params) {
		return new Promise(function(resolve) {
			instance
				.get(`report/${section}/export?`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res);
				});
		});
	},

	getOwnershipTypes: function() {
		return new Promise(function(resolve) {
			instance.get("/vehicles/ownershiptypes").then(res => {
				resolve(res.data);
			});
		});
	},
	getOwnershipSuppliers: function() {
		return new Promise(function(resolve) {
			instance.get("/vehicles/ownershipsuppliers").then(res => {
				resolve(res.data);
			});
		});
	},

	/* END VEHICLES */

	getBrandsData: function(pageIndex, sortColumn, sortDirection) {
		return new Promise(function(resolve) {
			instance.get("/brands?" + "page=" + pageIndex + "&sort=" + sortColumn + "&sortDirection=" + sortDirection).then(res => {
				resolve(res.data);
			});
		});
	},

	getDriversData: function(params) {
		return new Promise(function(resolve) {
			var qs = helpers.toQueryString(params);

			instance.get("/drivers?" + qs).then(res => {
				resolve(res.data);
			});
		});
	},
	getDriverDetail: function(id) {
		return new Promise(function(resolve, reject) {
			instance
				.get(`/driver/${id}`)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	},
	saveDriverDetail: function(id, name, surname, email, fiscal_code, mobile_phone_number, employee_register, rfid_code, is_dismissed, notes, groups) {
		var data = {
			id: id,
			name: name,
			surname: surname,
			email: email,
			fiscal_code: fiscal_code,
			mobile_phone_number: mobile_phone_number,
			groups: groups,
			employee_register: employee_register,
			rfid_code: rfid_code,
			is_dismissed: is_dismissed,
			notes: notes
		};

		if (id == 0) {
			return new Promise(function(resolve, reject) {
				instance
					.post("/driver", data)
					.then(res => {
						bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
						resolve(res);
					})
					.catch(err => {
						reject(err);
					});
			});
		} else {
			return new Promise(function(resolve, reject) {
				instance
					.put("/driver", data)
					.then(res => {
						bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
						resolve(res);
					})
					.catch(err => {
						reject(err);
					});
			});
		}
	},

	saveDriversVehiclesAssociation: function(inserted, updated, deleted) {
		var data = {
			insert: inserted,
			update: updated,
			delete: deleted
		};
		return new Promise(function(resolve, reject) {
			instance
				.post("/driver-vehicle/bulk", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	getDriversByVehicleId: function(vehicleId) {
		return new Promise(function(resolve) {
			instance.get(`/vehicles/${vehicleId}/drivers`).then(res => {
				resolve(res.data);
			});
		});
	},

	getVehiclesByDriverId: function(driverId) {
		return new Promise(function(resolve) {
			instance.get(`drivers/${driverId}/vehicles`).then(res => {
				resolve(res.data);
			});
		});
	},

	getVehicleEventsData: function(params) {
		return new Promise(function(resolve) {
			instance.get(`/lookups/vehicle-events${params ? "?type=" + params : ""}`).then(res => {
				resolve(res.data);
			});
		});
	},

	postVehicleEventsData: function(inserted, updated, deleted) {
		var data = {
			insert: inserted,
			update: updated,
			delete: deleted
		};
		return new Promise(function(resolve, reject) {
			instance
				.post("/lookups/vehicle-events", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	getGroupsData: function() {
		return new Promise(function(resolve) {
			instance.get("/lookups/groups").then(res => {
				resolve(res.data);
			});
		});
	},

	postGroupsData: function(inserted, updated, deleted) {
		var data = {
			insert: inserted,
			update: updated,
			delete: deleted
		};
		return new Promise(function(resolve, reject) {
			instance
				.post("/lookups/groups", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	getDrivingLicenseTypesData: function() {
		return new Promise(function(resolve) {
			instance.get("/lookups/driving-license-types").then(res => {
				resolve(res.data);
			});
		});
	},

	postDrivingLicenseTypesData: function(inserted, updated, deleted) {
		var data = {
			insert: inserted,
			update: updated,
			delete: deleted
		};
		return new Promise(function(resolve, reject) {
			instance
				.post("/lookups/driving-license-types", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	getCategoriesData: function() {
		return new Promise(function(resolve) {
			instance.get("/lookups/categories").then(res => {
				resolve(res.data);
			});
		});
	},

	postCategoriesData: function(inserted, updated, deleted) {
		var data = {
			insert: inserted,
			update: updated,
			delete: deleted
		};
		return new Promise(function(resolve, reject) {
			instance
				.post("/lookups/categories", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	getDivisionsData: function() {
		return new Promise(function(resolve) {
			instance.get("/lookups/divisions").then(res => {
				resolve(res.data);
			});
		});
	},

	getGeofenceVehicleTypes: function() {
		return new Promise(function(resolve) {
			instance.get("/lookups/geofence-vehicle-types").then(res => {
				resolve(res.data);
			});
		});
	},

	getAlertVehicleTypes: function() {
		return new Promise(function(resolve) {
			instance.get("/lookups/alert-vehicle-types").then(res => {
				resolve(res.data);
			});
		});
	},

	getAlertTypes: function() {
		return new Promise(function(resolve) {
			instance.get("/lookups/alert-types").then(res => {
				resolve(res.data);
			});
		});
	},

	postDivisionsData: function(inserted, updated, deleted) {
		var data = {
			insert: inserted,
			update: updated,
			delete: deleted
		};
		return new Promise(function(resolve, reject) {
			instance
				.post("/lookups/divisions", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	getVehicleStatesData: function() {
		return new Promise(function(resolve) {
			instance.get("/lookups/vehicle-states").then(res => {
				resolve(res.data);
			});
		});
	},

	postVehicleStatesData: function(inserted, updated, deleted) {
		var data = {
			insert: inserted,
			update: updated,
			delete: deleted
		};
		return new Promise(function(resolve, reject) {
			instance
				.post("/lookups/vehicle-states", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	getPoiCategoriesData: function() {
		return new Promise(function(resolve) {
			instance.get("/lookups/poi-categories").then(res => {
				resolve(res.data);
			});
		});
	},

	postPoiCategoriesData: function(inserted, updated, deleted) {
		var data = {
			insert: inserted,
			update: updated,
			delete: deleted
		};
		return new Promise(function(resolve, reject) {
			instance
				.post("/lookups/poi-categories", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	/* POI */
	getPoisData: function(query) {
		//var qs = helpers.toQueryString(query);
		return new Promise(function(resolve) {
			instance
				.get("/poi?", {
					params: query,
					paramsSerializer: params => {
						return qs.stringify(query);
					}
				})
				.then(res => {
					resolve(res.data);
				});
		});
	},

	postPoisData: function(data) {
		return new Promise(function(resolve, reject) {
			instance
				.post("/poi", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	deletePoi: function(id) {
		return new Promise(function(resolve, reject) {
			instance
				.delete(`/poi/${id}`)
				.then(res => {
					bus.$emit("successNotification", "Cancellazione avvenuta con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	/* END POI */

	/* USER  */

	getUserDivision: function(id) {
		return new Promise(function(resolve, reject) {
			instance
				.get("account/divisions")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	getMe: function(id) {
		return new Promise(function(resolve, reject) {
			instance
				.get("account/me")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	/* END USER */

	/* GEO LOCATION */
	getRealtimeGeolocation: function() {
		return new Promise(function(resolve, reject) {
			instance
				.get("trips/realtime")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	getRealtimeStatusGeolocation: function() {
		return new Promise(function(resolve, reject) {
			instance
				.get("trips/realtimestatus")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	getReverseGeocoding: function(params) {
		return new Promise(function(resolve, reject) {
			var qs = helpers.toQueryString(params);

			instance
				.get("geo/geocode?" + qs)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	getBulkReverseGeocoding: function(data) {
		return new Promise(function(resolve, reject) {
			instance
				.post("geo/geocode/bulk", data)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	setTripPositionDisplayName: function(data) {
		return new Promise(function(resolve, reject) {
			instance
				.post(`/trips/geo/displayname`, data)
				.then(res => {
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	setTripPositionDisplayNameBulk: function(data) {
		return new Promise(function(resolve, reject) {
			instance
				.post(`/trips/geo/displayname/bulk`, data)
				.then(res => {
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	/* PLANNER */
	getPlannerData: function(params) {
		return new Promise(function(resolve, reject) {
			instance
				.get("geo/planner", {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	},
	plannerSendMail: function(data) {
		return new Promise(function(resolve, reject) {
			instance
				.post("geo/planner/sendemail", data)
				.then(res => {
					bus.$emit("successNotification", "Invio mail effettuato con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},
	plannerPrint: function(data) {
		return new Promise(function(resolve) {
			instance.post("geo/planner/pdf", data).then(res => {
				resolve(res);
			});
		});
	},

	getFuelTypesData: function() {
		return new Promise(function(resolve) {
			instance.get("/lookups/fuel-types").then(res => {
				resolve(res.data);
			});
		});
	},

	/* REPORT */
	/* -- REPORT TRIPS --*/
	getTripsSynthetic: function(params) {
		return new Promise(function(resolve) {
			var qs = helpers.toQueryString(params);

			instance.get("report/trips/synthetic?" + qs).then(res => {
				resolve(res.data);
			});
		});
	},
	getTripsDetail: function(params) {
		return new Promise(function(resolve) {
			var qs = helpers.toQueryString(params);

			instance.get("report/trips/details?" + qs).then(res => {
				resolve(res.data);
			});
		});
	},
	/* -- REPORT TRIPS --*/
	/* -- REPORT UTILIZATION -- */
	getTotalTimings: function(params) {
		return new Promise(function(resolve) {
			var qs = helpers.toQueryString(params);

			instance.get("report/timings/total?" + qs).then(res => {
				resolve(res.data);
			});
		});
	},
	getPercentageDailyTimings: function(params) {
		return new Promise(function(resolve) {
			var qs = helpers.toQueryString(params);

			instance.get("report/timings/dayofweek?" + qs).then(res => {
				resolve(res.data);
			});
		});
	},
	/* -- REPORT UTILIZATION -- */
	/* -- REPORT JOURNEY --*/
	getJourneySynthetic: function(params) {
		return new Promise(function(resolve) {
			var qs = helpers.toQueryString(params);

			instance.get("report/journey/synthetic?" + qs).then(res => {
				resolve(res.data);
			});
		});
	},
	getJourneySyntheticChart: function(params) {
		return new Promise(function(resolve) {
			var qs = helpers.toQueryString(params);

			instance.get("report/journey/syntheticchart?" + qs).then(res => {
				resolve(res.data);
			});
		});
	},
	getJourneySyntheticPaged: function(params) {
		return new Promise(function(resolve) {
			var qs = helpers.toQueryString(params);

			instance.get("report/journey/syntheticpaged?" + qs).then(res => {
				resolve(res.data);
			});
		});
	},
	getJourneyDetail: function(params) {
		return new Promise(function(resolve) {
			var qs = helpers.toQueryString(params);

			instance.get("report/journey/details?" + qs).then(res => {
				resolve(res.data);
			});
		});
	},
	/* -- REPORT JOURNEY --*/
	/* -- REPORT ALARMS --*/
	getAlarmsReport: function(params) {
		return new Promise(function(resolve) {
			//var qs = helpers.toQueryString(params);
			instance
				.get(`report/alarms`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				});
		});
	},
	getAlarmsChartReport: function(params) {
		return new Promise(function(resolve) {
			//var qs = helpers.toQueryString(params);
			instance
				.get(`report/alarms-counter`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				});
		});
	},
	/* -- REPORT ALARMS --*/
	/* -- REPORT DIAGNOSIS --*/
	getDiagnosticReportChartData: function(params) {
		return new Promise(function(resolve) {
			instance
				.get(`report/diagnosis/chart`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				});
		});
	},
	getDiagnosticReportData: function(params) {
		return new Promise(function(resolve) {
			instance
				.get(`report/diagnosis`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				});
		});
	},
	/* -- REPORT DIAGNOSIS --*/
	/* -- REPORT BEHAVIORS --*/
	getBehaviorsGridReport: function(params) {
		return new Promise(function(resolve) {
			//var qs = helpers.toQueryString(params);
			instance
				.get(`report/drivers/behaviors`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				});
		});
	},
	geBehaviorsChartReport: function(params) {
		return new Promise(function(resolve) {
			//var qs = helpers.toQueryString(params);
			instance
				.get(`report/drivers/behaviors-counter`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				});
		});
	},
	/* -- REPORT BEHAVIORS --*/
	/* -- REPORT EVENT TRPS --*/
	getEventTripsDetailReport: function(params) {
		return new Promise(function(resolve) {
			instance
				.get(`report/trips/events`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				});
		});
	},

	/* -- REPORT EVENT TRPS --*/
	/* -- REPORT LAST DIAGNOSIS --*/
	getLastDiagnosticReportChartData: function(params) {
		return new Promise(function(resolve) {
			instance
				.get(`report/last-diagnosis/chart`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				});
		});
	},
	getLastDiagnosticReportData: function(params) {
		return new Promise(function(resolve) {
			instance
				.get(`report/last-diagnosis`, {
					params: params,
					paramsSerializer: params => {
						return qs.stringify(params);
					}
				})
				.then(res => {
					resolve(res.data);
				});
		});
	},
	/* -- REPORT LAST DIAGNOSIS --*/
	/* REPORT */

	/* GEOFENCE */
	getGeofencesList: function(params) {
		return new Promise(function(resolve) {
			var qs = helpers.toQueryString(params);
			instance.get("/geofences?" + qs).then(res => {
				resolve(res.data);
			});
		});
	},
	getGeofenceDetailData: function(id) {
		return new Promise(function(resolve) {
			instance.get(`/geofence/${id}`).then(res => {
				resolve(res.data);
			});
		});
	},
	saveGeofenceDetail: function(data) {
		if (data.id == 0) {
			return new Promise(function(resolve, reject) {
				instance
					.post("/geofence", data)
					.then(res => {
						bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
						resolve(res);
					})
					.catch(err => {
						reject(err);
					});
			});
		} else {
			return new Promise(function(resolve, reject) {
				instance
					.put("/geofence", data)
					.then(res => {
						bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
						resolve(res);
					})
					.catch(err => {
						reject(err);
					});
			});
		}
	},
	deleteGeofence: function(id) {
		return new Promise(function(resolve, reject) {
			instance
				.delete(`/geofence/${id}`)
				.then(res => {
					bus.$emit("successNotification", "Cancellazione avvenuta con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},
	getVehiclesByGeofenceId: function(geofenceId) {
		return new Promise(function(resolve) {
			instance.get(`geofence/${geofenceId}/vehicles`).then(res => {
				resolve(res.data);
			});
		});
	},
	saveGeofenceVehiclesAssociation: function(inserted, updated, deleted) {
		var data = {
			insert: inserted,
			update: updated,
			delete: deleted
		};
		return new Promise(function(resolve, reject) {
			instance
				.post("/geofence-vehicle/bulk", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},
	/* GEOFENCE */

	/* ALERTS */
	getAlertsData: function(params) {
		return new Promise(function(resolve) {
			var qs = helpers.toQueryString(params);

			instance.get("/alerts?" + qs).then(res => {
				resolve(res.data);
			});
		});
	},
	getAlertDetailData: function(id) {
		return new Promise(function(resolve) {
			instance.get(`/alerts/${id}`).then(res => {
				resolve(res.data);
			});
		});
	},
	saveAlertDetail: function(data) {
		return new Promise(function(resolve, reject) {
			instance
				.put("/alerts", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},
	getVehiclesByAlertId: function(alertId) {
		return new Promise(function(resolve) {
			instance.get(`alerts/${alertId}/vehicles`).then(res => {
				resolve(res.data);
			});
		});
	},
	saveAlertVehiclesAssociation: function(inserted, updated, deleted) {
		var data = {
			insert: inserted,
			update: updated,
			delete: deleted
		};
		return new Promise(function(resolve, reject) {
			instance
				.post("/alert-vehicle/bulk", data)
				.then(res => {
					bus.$emit("successNotification", "Salvataggio avvenuto con successo!");
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	},
	/* ALERTS */

	supportSendMail: function(data) {
		return new Promise(function(resolve, reject) {
			instance
				.post(`support/request`, data)
				.then(res => {
					bus.$emit("successNotification", "Invio mail effettuato con successo!");
					resolve(res);
				})
				.catch(err => {
					var messages = ["Errore nell'invio della mail"];
					bus.$emit("responseNotification", {
						status: "error",
						messages: messages
					});
					reject(err);
				});
		});
	}
};

export default api;
